/**
 * Storefront Pixel Tracking - PageView, ViewContent, AddToCart (Client-Side + Server-Side)
 * Reads config from window.__pixelConfig and product data from window.variantProductData
 * All prices are in the store's local currency (no USD conversion).
 */
(function() {
  'use strict';

  var CFG = window.__pixelConfig || {};
  var hasPlaceholder = function(v) { return !v || v.indexOf('{') === 0; };
  var CURRENCY = CFG.currency || 'USD';

  console.log('[Pixels] Init — config:', {
    fb: !hasPlaceholder(CFG.fbPixelId),
    tt: !hasPlaceholder(CFG.ttPixelId),
    ga: !hasPlaceholder(CFG.gaId),
    snap: !hasPlaceholder(CFG.snapPixelId),
    server: !hasPlaceholder(CFG.serverPixelUrl),
    currency: CURRENCY
  });

  // --- Pixel Base Script Initialization ---

  // Pre-generate PageView eventId for client/server dedup
  var _pageViewEventId = generateEventId('pv');

  // Facebook
  if (!hasPlaceholder(CFG.fbPixelId)) {
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
    (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', CFG.fbPixelId);
    fbq('track', 'PageView', {}, { eventID: _pageViewEventId });
    console.log('[Pixels] Facebook pixel initialized:', CFG.fbPixelId, 'PV eventID:', _pageViewEventId);
  }

  // TikTok
  if (!hasPlaceholder(CFG.ttPixelId)) {
    !function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
    ttq.methods=["page","track","identify","instances","debug","on","off","once","ready",
    "alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
    for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
    ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};
    ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";
    ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=r;ttq._t=ttq._t||{};ttq._t[e]=+new Date;
    ttq._o=ttq._o||{};ttq._o[e]=n||{};var a=document.createElement("script");
    a.type="text/javascript";a.async=!0;a.src=r+"?sdkid="+e+"&lib="+t;
    var s=document.getElementsByTagName("script")[0];s.parentNode.insertBefore(a,s)}}
    (window,document,"ttq");
    ttq.load(CFG.ttPixelId);
    ttq.page();
    console.log('[Pixels] TikTok pixel initialized:', CFG.ttPixelId);
  }

  // Google Analytics 4
  if (!hasPlaceholder(CFG.gaId)) {
    var gs = document.createElement('script');
    gs.async = true;
    gs.src = 'https://www.googletagmanager.com/gtag/js?id=' + CFG.gaId;
    document.head.appendChild(gs);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { dataLayer.push(arguments); };
    gtag('js', new Date());
    gtag('config', CFG.gaId);
    console.log('[Pixels] GA4 initialized:', CFG.gaId);
  }

  // Snapchat
  if (!hasPlaceholder(CFG.snapPixelId)) {
    (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){
    a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
    a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;r.src=n;
    var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u)})
    (window,document,'https://sc-static.net/scevent.min.js');
    snaptr('init', CFG.snapPixelId);
    snaptr('track', 'PAGE_VIEW', { client_dedup_id: _pageViewEventId });
    console.log('[Pixels] Snapchat pixel initialized:', CFG.snapPixelId, 'PV dedup:', _pageViewEventId);
  }

  // --- Tracking Params Collection ---

  function getTrackingParams() {
    var params = new URLSearchParams(window.location.search);
    var fbclid = params.get('fbclid');
    var fbc = getCookie('_fbc');
    // FB pixel may not have created _fbc cookie yet — construct from fbclid
    if (!fbc && fbclid) {
      fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    }
    return {
      fbp: getCookie('_fbp'),
      fbc: fbc,
      fbclid: fbclid,
      ttp: getCookie('_ttp'),
      ttclid: params.get('ttclid'),
      sc_click_id: params.get('ScCid'),
      sc_cookie1: getCookie('_scid'),
      ga_client_id: (document.cookie.match(/_ga=GA\d+\.\d+\.([^;]+)/) || [])[1] || null,
      ga_session_id: (document.cookie.match(/_ga_[^=]+=GS\d+\.\d+\.(\d+)/) || [])[1] || null,
      gclid: params.get('gclid')
    };
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
    return m ? m[1] : null;
  }

  // --- Event ID Generator ---

  function generateEventId(prefix) {
    return (prefix || 'ev') + '_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // --- Parse request body helpers ---

  function parseAddToCartBody(args) {
    try {
      var opts = args[1];
      if (!opts || !opts.body) return null;
      if (typeof opts.body === 'string') return JSON.parse(opts.body);
      if (opts.body instanceof FormData) {
        var obj = {};
        opts.body.forEach(function(v, k) { obj[k] = v; });
        return obj;
      }
    } catch(e) {}
    return null;
  }

  // --- Fire Client-Side AddToCart Events ---

  function fireClientPixels(product, value, currency, eventId) {
    var pid = String(product.id || product.si || '');
    var name = product.name || '';
    var price = parseFloat(product.price || 0);
    var qty = parseInt(product.quantity || 1);
    var val = parseFloat(value);

    // Log what tracking cookies the client pixels will read
    var tp = getTrackingParams();
    console.log('[Pixels] Client tracking params at fire time:', {
      fbp: tp.fbp, fbc: tp.fbc, fbclid: tp.fbclid,
      ttp: tp.ttp, ttclid: tp.ttclid,
      ga_client_id: tp.ga_client_id, ga_session_id: tp.ga_session_id, gclid: tp.gclid,
      sc_click_id: tp.sc_click_id, sc_cookie1: tp.sc_cookie1
    });

    // Facebook
    if (window.fbq) {
      var fbData = { content_ids: [pid], content_type: 'product', content_name: name, value: val, currency: currency };
      fbq('track', 'AddToCart', fbData, { eventID: eventId });
      console.log('[Pixels] FB AddToCart fired:', { eventID: eventId, data: fbData });
    }

    // TikTok
    if (window.ttq) {
      var ttData = { contents: [{ content_id: pid, content_type: 'product', content_name: name, quantity: qty, price: price }], value: val, currency: currency };
      ttq.track('AddToCart', ttData, { event_id: eventId });
      console.log('[Pixels] TT AddToCart fired:', { event_id: eventId, data: ttData });
    }

    // Google
    if (window.gtag) {
      var gaData = { items: [{ item_id: pid, item_name: name, price: price, quantity: qty }], value: val, currency: currency };
      gtag('event', 'add_to_cart', gaData);
      console.log('[Pixels] GA4 add_to_cart fired:', gaData);
    }

    // Snapchat
    if (window.snaptr) {
      var snapData = { item_ids: [pid], price: val, currency: currency, client_dedup_id: eventId };
      snaptr('track', 'ADD_CART', snapData);
      console.log('[Pixels] Snap ADD_CART fired:', snapData);
    }
  }

  // --- Fire Client-Side ViewContent Events ---

  function fireClientViewContent(product, value, currency, eventId) {
    var pid = String(product.id || '');
    var name = product.name || '';
    var price = parseFloat(product.price || 0);
    var val = parseFloat(value);

    console.log('[Pixels] Client ViewContent firing:', { pid: pid, name: name, price: price, value: val, currency: currency, eventId: eventId });

    if (window.fbq) {
      var fbData = { content_ids: [pid], content_type: 'product', content_name: name, value: val, currency: currency };
      fbq('track', 'ViewContent', fbData, { eventID: eventId });
      console.log('[Pixels] FB ViewContent fired:', { eventID: eventId, data: fbData });
    }

    if (window.ttq) {
      var ttData = { contents: [{ content_id: pid, content_type: 'product', content_name: name, quantity: 1, price: price }], value: val, currency: currency };
      ttq.track('ViewContent', ttData, { event_id: eventId });
      console.log('[Pixels] TT ViewContent fired:', { event_id: eventId, data: ttData });
    }

    if (window.gtag) {
      var gaData = { items: [{ item_id: pid, item_name: name, price: price, quantity: 1 }], value: val, currency: currency };
      gtag('event', 'view_item', gaData);
      console.log('[Pixels] GA4 view_item fired:', gaData);
    }

    if (window.snaptr) {
      var snapData = { item_ids: [pid], price: val, currency: currency, client_dedup_id: eventId };
      snaptr('track', 'VIEW_CONTENT', snapData);
      console.log('[Pixels] Snap VIEW_CONTENT fired:', snapData);
    }
  }

  // --- Build Server Pixel Payload ---

  function buildServerPayload(eventName, product, value, currency, eventId) {
    var tp = getTrackingParams();

    var pixels = {};
    if (!hasPlaceholder(CFG.fbPixelId) && !hasPlaceholder(CFG.fbAccessToken)) {
      pixels.fb_pixel_id = CFG.fbPixelId;
      pixels.fb_access_token = CFG.fbAccessToken;
    }
    if (!hasPlaceholder(CFG.ttPixelId) && !hasPlaceholder(CFG.ttAccessToken)) {
      pixels.tt_pixel_id = CFG.ttPixelId;
      pixels.tt_access_token = CFG.ttAccessToken;
    }
    if (!hasPlaceholder(CFG.gaId) && !hasPlaceholder(CFG.gaSecret)) {
      pixels.ga_id = CFG.gaId;
      pixels.ga_secret = CFG.gaSecret;
    }
    if (!hasPlaceholder(CFG.snapPixelId) && !hasPlaceholder(CFG.snapAccessToken)) {
      pixels.snap_pixel_id = CFG.snapPixelId;
      pixels.snap_access_token = CFG.snapAccessToken;
    }

    if (Object.keys(pixels).length === 0) {
      console.log('[Pixels] No server pixel credentials configured, skipping server event');
      return null;
    }

    return {
      event: eventName,
      event_id: eventId,
      currency: currency,
      value: parseFloat(value),
      pageUrl: window.location.href,
      products: [{
        id: String(product.id || product.si || ''),
        name: product.name || '',
        price: parseFloat(product.price || 0),
        quantity: parseInt(product.quantity || 1)
      }],
      pixels: pixels,
      fbp: tp.fbp,
      fbc: tp.fbc,
      fbclid: tp.fbclid,
      ttp: tp.ttp,
      ttclid: tp.ttclid,
      sc_click_id: tp.sc_click_id,
      sc_cookie1: tp.sc_cookie1,
      ga_client_id: tp.ga_client_id,
      ga_session_id: tp.ga_session_id,
      gclid: tp.gclid
    };
  }

  // --- Send Server Event (sendBeacon for reliability during navigation) ---

  function sendServerEvent(payload) {
    if (!payload) return;
    var url = CFG.serverPixelUrl;
    if (hasPlaceholder(url)) return;

    console.log('[Pixels] Server ' + payload.event + ' payload:', {
      event: payload.event,
      event_id: payload.event_id,
      value: payload.value,
      currency: payload.currency,
      fbp: payload.fbp,
      fbc: payload.fbc,
      fbclid: payload.fbclid,
      ttp: payload.ttp,
      ttclid: payload.ttclid,
      gclid: payload.gclid,
      sc_click_id: payload.sc_click_id,
      sc_cookie1: payload.sc_cookie1,
      ga_client_id: payload.ga_client_id,
      ga_session_id: payload.ga_session_id,
      pixels: Object.keys(payload.pixels)
    });

    var jsonStr = JSON.stringify(payload);
    var sent = false;

    // Use sendBeacon — survives page navigation
    if (navigator.sendBeacon) {
      var blob = new Blob([jsonStr], { type: 'text/plain' });
      sent = navigator.sendBeacon(url, blob);
      console.log('[Pixels] sendBeacon ' + payload.event + ':', sent ? 'queued' : 'FAILED');
    }

    // Fallback to fetch if sendBeacon failed or unavailable
    if (!sent) {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: jsonStr,
        keepalive: true
      }).then(function(r) {
        console.log('[Pixels] fetch fallback ' + payload.event + ': HTTP', r.status);
      }).catch(function(e) {
        console.error('[Pixels] Server ' + payload.event + ' failed:', e);
        // Queue for retry on next page load
        queueServerEvent(payload);
      });
    }
  }

  // --- Queue / Flush pending server events via sessionStorage ---

  var QUEUE_KEY = '__pixelQueue';

  function queueServerEvent(payload) {
    try {
      var queue = JSON.parse(sessionStorage.getItem(QUEUE_KEY) || '[]');
      queue.push(payload);
      sessionStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
      console.log('[Pixels] Queued event for retry:', payload.event, payload.event_id);
    } catch(e) {}
  }

  function flushQueuedEvents() {
    try {
      var raw = sessionStorage.getItem(QUEUE_KEY);
      if (!raw) return;
      var queue = JSON.parse(raw);
      if (!queue.length) return;
      sessionStorage.removeItem(QUEUE_KEY);
      console.log('[Pixels] Flushing', queue.length, 'queued server event(s)');
      queue.forEach(function(payload) {
        sendServerEvent(payload);
      });
    } catch(e) {}
  }

  // --- Main: Process /cart/add response ---

  function processCartAddResponse(responseData, requestBody) {
    if (!responseData) {
      console.log('[Pixels] /cart/add response empty or unparseable');
      return;
    }

    console.log('[Pixels] /cart/add response:', responseData);

    // Single item response (has variant_id or key at top level)
    if (responseData.variant_id || responseData.key) {
      processCartItem(responseData, requestBody);
      return;
    }

    // Multi-item response { items: [...] }
    if (Array.isArray(responseData.items)) {
      console.log('[Pixels] Multi-item response, items:', responseData.items.length);
      responseData.items.forEach(function(item) {
        processCartItem(item, null);
      });
      return;
    }

    console.log('[Pixels] Unknown /cart/add response format');
  }

  // --- Decode Kaching bundle property ---

  function decodeKachingProp(prop) {
    if (!prop) return null;
    try { return JSON.parse(atob(prop)); } catch(e) { return null; }
  }

  function getVariantRealPrice(variantId) {
    var map = window.variantProductData || {};
    var data = map[variantId];
    if (data && data.price > 0) return data.price;
    return 0;
  }

  function processCartItem(item, requestBody) {
    if (!item) return;

    var variantId = item.variant_id || item.id;
    var priceCents = item.final_price != null ? item.final_price : (item.price || 0);
    var kachingProp = (item.properties && item.properties.__kaching_bundles) || null;
    var kachingData = decodeKachingProp(kachingProp);

    console.log('[Pixels] Processing item:', {
      variant_id: variantId,
      title: item.product_title || item.title,
      final_price: priceCents,
      original_price: item.original_price,
      quantity: item.quantity,
      kaching: kachingData
    });

    // Kaching bundles set final_price=0 for ALL items in the bundle.
    // Decode the property to check: main=true means real product, main=false means freebie.
    if (kachingData) {
      if (!kachingData.main) {
        console.log('[Pixels] Skipping bundle freebie (main=false):', variantId);
        return;
      }

      // Main bundle item — Kaching zeroes the price, get real price from variant data
      if (priceCents === 0) {
        // Try original_price from response, then variantProductData map
        priceCents = item.original_price || getVariantRealPrice(variantId);
        console.log('[Pixels] Kaching main item, resolved real price:', priceCents);
      }
    }

    if (priceCents === 0) {
      console.log('[Pixels] Skipping zero-price item:', variantId);
      return;
    }

    var qty = parseInt(item.quantity || 1);

    // Price in local currency (cents -> decimal, no conversion)
    var localPrice = priceCents / 100;
    var value = localPrice * qty;

    localPrice = Math.round(localPrice * 100) / 100;
    value = Math.round(value * 100) / 100;

    var productForPixels = {
      id: item.product_id || variantId,
      si: item.product_id || '',
      name: item.product_title || item.title || '',
      price: localPrice,
      quantity: qty
    };

    var eventId = generateEventId('atc');

    console.log('[Pixels] AddToCart firing:', {
      product: productForPixels,
      value: value,
      currency: CURRENCY,
      eventId: eventId
    });

    fireClientPixels(productForPixels, value, CURRENCY, eventId);

    var payload = buildServerPayload('AddToCart', productForPixels, value, CURRENCY, eventId);
    sendServerEvent(payload);
  }

  // --- Cart Snapshot for ATC Detection ---

  var CART_SNAP_KEY = '__pixelsCartSnap';

  function snapshotCart() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var snap = {};
      (cart.items || []).forEach(function(item) {
        snap[item.variant_id] = (snap[item.variant_id] || 0) + item.quantity;
      });
      sessionStorage.setItem(CART_SNAP_KEY, JSON.stringify(snap));
    }).catch(function() {});
  }

  function detectCartATC() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var prevSnap = {};
      try { prevSnap = JSON.parse(sessionStorage.getItem(CART_SNAP_KEY) || '{}'); } catch(e) {}

      // Build current snapshot
      var currentSnap = {};
      (cart.items || []).forEach(function(item) {
        currentSnap[item.variant_id] = (currentSnap[item.variant_id] || 0) + item.quantity;
      });

      // Save updated snapshot immediately
      sessionStorage.setItem(CART_SNAP_KEY, JSON.stringify(currentSnap));

      // Find newly added items (quantity delta)
      var newItems = [];
      (cart.items || []).forEach(function(item) {
        var prevQty = prevSnap[item.variant_id] || 0;
        var addedQty = item.quantity - prevQty;
        if (addedQty > 0) {
          newItems.push({ item: item, addedQty: addedQty });
        }
      });

      if (newItems.length === 0) {
        console.log('[Pixels] Cart page: no new items detected');
        return;
      }

      console.log('[Pixels] Cart page: detected', newItems.length, 'new item(s)');

      newItems.forEach(function(entry) {
        var item = entry.item;
        var qty = entry.addedQty;
        var priceCents = item.final_price != null ? item.final_price : (item.price || 0);

        // Handle Kaching bundles
        var kachingProp = (item.properties && item.properties.__kaching_bundles) || null;
        var kachingData = decodeKachingProp(kachingProp);
        if (kachingData && !kachingData.main) {
          console.log('[Pixels] Skipping bundle freebie on cart page:', item.variant_id);
          return;
        }
        if (kachingData && kachingData.main && priceCents === 0) {
          priceCents = item.original_price || getVariantRealPrice(item.variant_id);
        }

        if (priceCents === 0) return;

        var localPrice = Math.round(priceCents) / 100;
        localPrice = Math.round(localPrice * 100) / 100;
        var value = Math.round(localPrice * qty * 100) / 100;

        var productForPixels = {
          id: item.product_id || item.variant_id,
          si: item.product_id || '',
          name: item.product_title || item.title || '',
          price: localPrice,
          quantity: qty
        };

        var eventId = generateEventId('atc');

        console.log('[Pixels] AddToCart firing (cart page):', {
          product: productForPixels,
          value: value,
          currency: CURRENCY,
          eventId: eventId
        });

        fireClientPixels(productForPixels, value, CURRENCY, eventId);
        var payload = buildServerPayload('AddToCart', productForPixels, value, CURRENCY, eventId);
        sendServerEvent(payload);
      });
    }).catch(function(e) {
      console.error('[Pixels] Cart ATC detection failed:', e);
    });
  }

  // --- Intercept Add-to-Cart (fetch-based themes) ---

  function setup() {
    console.log('[Pixels] Setting up /cart/add interceptor...');

    var origFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');

      var promise = origFetch.apply(this, args);

      if (url.includes('/cart/add')) {
        console.log('[Pixels] Intercepted /cart/add fetch:', url);
        var requestBody = parseAddToCartBody(Array.from(args));
        console.log('[Pixels] Request body:', requestBody);

        // Process pixels in background — don't block the response chain
        promise.then(function(res) {
          try {
            res.clone().json().then(function(responseData) {
              processCartAddResponse(responseData, requestBody);
              // Update cart snapshot so cart page doesn't double-fire
              snapshotCart();
            }).catch(function(e) {
              console.error('[Pixels] Failed to parse /cart/add response:', e);
            });
          } catch(e) {
            console.error('[Pixels] Failed to clone /cart/add response:', e);
          }
        }).catch(function() {});
      }

      return promise;
    };

    console.log('[Pixels] Interceptor ready');
  }

  // --- Server-Side PageView (all pages) ---

  function firePageView() {
    console.log('[Pixels] Firing server PageView:', _pageViewEventId);
    var payload = buildServerPayload('PageView', { id: '', name: document.title, price: 0, quantity: 1 }, 0, CURRENCY, _pageViewEventId);
    sendServerEvent(payload);
  }

  // --- ViewContent (product pages only — needs window.__currentProduct) ---

  function fireViewContent() {
    var product = window.__currentProduct;
    if (!product) {
      console.log('[Pixels] No __currentProduct, skipping ViewContent');
      return;
    }

    // Price from Shopify cents -> local currency decimal
    var price = (product.price || 0) / 100;
    price = Math.round(price * 100) / 100;

    var eventId = generateEventId('vc');
    var productForPixels = {
      id: product.id || '',
      name: product.name || '',
      price: price,
      quantity: 1
    };

    console.log('[Pixels] ViewContent firing:', {
      product: productForPixels,
      value: price,
      currency: CURRENCY,
      eventId: eventId
    });

    // Client-side ViewContent pixels
    fireClientViewContent(productForPixels, price, CURRENCY, eventId);

    // Server-side ViewContent CAPI
    var payload = buildServerPayload('ViewContent', productForPixels, price, CURRENCY, eventId);
    sendServerEvent(payload);
  }

  // --- Init ---

  function init() {
    flushQueuedEvents();
    setup();
    firePageView();
    fireViewContent();

    // Cart page: detect items added via native form POST
    if (window.location.pathname === '/cart') {
      detectCartATC();
    } else {
      // Non-cart pages: snapshot cart for later comparison
      snapshotCart();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
